module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Regular.ae18f767.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-Pro-Display-Regular.otf
// module id = 2160
// module chunks = 0